import { render, staticRenderFns } from "./placard_order_nav.vue?vue&type=template&id=c6b852ac&scoped=true"
import script from "./placard_order_nav.vue?vue&type=script&lang=js"
export * from "./placard_order_nav.vue?vue&type=script&lang=js"
import style0 from "./placard_order_nav.vue?vue&type=style&index=0&id=c6b852ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b852ac",
  null
  
)

export default component.exports